"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BallTypeEnum = void 0;
var BallTypeEnum;
(function (BallTypeEnum) {
    BallTypeEnum["HIGH_ALTITUDE"] = "HIGH_ALTITUDE";
    BallTypeEnum["STAGE1GREEN"] = "STAGE1GREEN";
    BallTypeEnum["STAGE2ORANGE"] = "STAGE2ORANGE";
    BallTypeEnum["STAGE3RED"] = "STAGE3RED";
    BallTypeEnum["T2STANDARD_PRESSURELESS"] = "T2STANDARD_PRESSURELESS";
    BallTypeEnum["T2STANDARD_PRESSURISED"] = "T2STANDARD_PRESSURISED";
    BallTypeEnum["TYPE1FAST"] = "TYPE1FAST";
    BallTypeEnum["TYPE3SLOW"] = "TYPE3SLOW";
})(BallTypeEnum || (exports.BallTypeEnum = BallTypeEnum = {}));
//# sourceMappingURL=ball_type.js.map